import _ = require("underscore");
import m = require("mithril");
import prop = require("mithril/stream");
import {Vnode} from "mithril";


export class ScrollableDiv {
    public static component = {
        view: (vnode :Vnode) => {
            return m(ScrollableDiv, vnode.attrs);
        }
    };
    private dragging = prop(false);
    private beginPos = prop([0, 0]);
    private actualPos = prop([0, 0]);
    private element = prop<Element>();
    private viewport: any;
    private content: any;

    constructor(attr: any) {
        this.viewport = attr.viewport;
        this.content = attr.content;
    }

    view() {
        return m('div.imageContainer', {
            onupdate: vnode => this.element(vnode.dom),
            style: `width: ${this.viewport.width}px; height: ${this.viewport.height}px;cursor:all-scroll`,
            scrollLeft: this.actualPos()[0],
            scrollTop: this.actualPos()[1],
            onmousedown: (e: MouseEvent) => {
                this.beginPos([e.screenX + this.actualPos()[0], e.screenY + this.actualPos()[1]]);
                this.dragging(true);
            },
            onmouseup: () => this.dragging(false),
            onmouseout: () => this.dragging(false),
            onmousemove: (e: MouseEvent) => {
                if (this.dragging()) {
                    const beginPos = this.beginPos();
                    this.updateActualPos([(beginPos[0] - e.screenX), (beginPos[1] - e.screenY)]);
                }
            },
            onscroll: (e: any) => this.updateActualPos([e.target.scrollLeft, e.target.scrollTop]),
            ondragstart: () => false // prevent Firefox image dragging
        }, this.content);
    }

    updateActualPos(pos: number[]) {
        const e = this.element();
        const x = _.min([e.scrollWidth - e.clientWidth, pos[0]]);
        const y = _.min([e.scrollHeight - e.clientHeight, pos[1]]);
        this.actualPos([_.max([0, x]), _.max([0, y])]);
    }

}
